import {
    CHANGE_LIBRARY_GOAL_MASTERY,
    CHANGE_LIBRARY_GOAL_TARGET_MASTERY,
    CHANGE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY,
    CHOOSE_OPTIONS_FROM_LIBRARY_GOAL,
    CHOOSE_TARGETS_FROM_LIBRARY_GOAL,
    CREATE_LIBRARY_FOLDER,
    CLONE_LIBRARY_GOAL,
    CREATE_LIBRARY_GOAL,
    CREATE_LIBRARY_GOAL_OPTION,
    CREATE_LIBRARY_GOAL_TARGET,
    CREATE_LIBRARY_OPTION,
    CREATE_LIBRARY_TARGET,
    DELETE_LIBRARY_FOLDER,
    DELETE_LIBRARY_GOAL,
    DELETE_LIBRARY_GOAL_OPTION,
    DELETE_LIBRARY_GOAL_TARGET,
    DELETE_LIBRARY_OPTION,
    DELETE_LIBRARY_TARGET,
    EDIT_LIBRARY_FOLDER,
    EDIT_LIBRARY_GOAL,
    EDIT_LIBRARY_GOAL_OPTION,
    EDIT_LIBRARY_GOAL_TARGET,
    EDIT_LIBRARY_OPTION,
    EDIT_LIBRARY_TARGET,
    GET_LIBRARY_FOLDERS,
    GET_LIBRARY_GOAL_BY_ID,
    GET_LIBRARY_GOALS,
    UPSERT_LIBRARY_SECTION_DESCRIPTION_BLOCK,
    DELETE_LIBRARY_SECTION_DESCRIPTION_BLOCK,
    REMOVE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY,
    REORDER_LIBRARY_GOAL_OPTION,
    REORDER_LIBRARY_GOAL_TARGET,
    CHANGE_LIBRARY_TARGET_MAINTENANCE,
    ADD_LIBRARY_TARGET_MAINTENANCE_STEP,
    EDIT_LIBRARY_TARGET_MAINTENANCE_STEP,
    DELETE_LIBRARY_TARGET_MAINTENANCE_STEP,
    CHANGE_SINGLE_LIBRARY_TARGET_MAINTENANCE,
    ADD_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP,
    EDIT_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP,
    DELETE_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP,
    SINGLE_LIBRARY_TARGET_FOLLOW_GOAL_CONFIG,
    SINGLE_LIBRARY_TARGET_MASTERY_FOLLOW_GOAL,
} from './library.types';

/** Goals */

export const getLibraryGoals = (params, load) => {
    return {
        type: GET_LIBRARY_GOALS,
        payload: { params, load },
    };
};

export const createLibraryGoal = (body, requestParams) => {
    return {
        type: CREATE_LIBRARY_GOAL,
        payload: { body, requestParams },
    };
};

export const editLibraryGoal = (id, body, requestParams) => {
    return {
        type: EDIT_LIBRARY_GOAL,
        payload: { id, body, requestParams },
    };
};

export const deleteLibraryGoal = (id, requestParams) => {
    return {
        type: DELETE_LIBRARY_GOAL,
        payload: { id, requestParams },
    };
};

export const cloneLibraryGoal = (id, data, requestParams) => {
    return {
        type: CLONE_LIBRARY_GOAL,
        payload: { id, data, requestParams },
    };
};

export const getLibraryGoalById = (id) => {
    return {
        type: GET_LIBRARY_GOAL_BY_ID,
        payload: { id },
    };
};

export const upsertLibrarySectionDescriptionBlock = (goalId, body) => {
    return {
        type: UPSERT_LIBRARY_SECTION_DESCRIPTION_BLOCK,
        payload: { goalId, body },
    };
};

export const deleteLibrarySectionDescriptionBlock = (goalId, sectionTypeId) => {
    return {
        type: DELETE_LIBRARY_SECTION_DESCRIPTION_BLOCK,
        payload: { goalId, sectionTypeId },
    };
};

export const createLibraryGoalTarget = (goalId, body) => {
    return {
        type: CREATE_LIBRARY_GOAL_TARGET,
        payload: { goalId, body },
    };
};

export const editLibraryGoalTarget = (goalId, targetId, body) => {
    return {
        type: EDIT_LIBRARY_GOAL_TARGET,
        payload: { goalId, targetId, body },
    };
};

export const deleteLibraryGoalTarget = (goalId, targetId) => {
    return {
        type: DELETE_LIBRARY_GOAL_TARGET,
        payload: { goalId, targetId },
    };
};

export const reorderLibraryGoalTarget = (goalId, reorder) => {
    return {
        type: REORDER_LIBRARY_GOAL_TARGET,
        payload: { goalId, reorder },
    };
};

export const createLibraryGoalOption = (goalId, body) => {
    return {
        type: CREATE_LIBRARY_GOAL_OPTION,
        payload: { goalId, body },
    };
};

export const editLibraryGoalOption = (goalId, targetId, body) => {
    return {
        type: EDIT_LIBRARY_GOAL_OPTION,
        payload: { goalId, targetId, body },
    };
};

export const deleteLibraryGoalOption = (goalId, targetId) => {
    return {
        type: DELETE_LIBRARY_GOAL_OPTION,
        payload: { goalId, targetId },
    };
};

export const reorderLibraryGoalOption = (goalId, reorder) => {
    return {
        type: REORDER_LIBRARY_GOAL_OPTION,
        payload: { goalId, reorder },
    };
};

export const chooseTargetsFromLibraryGoal = (goalId, body) => {
    return {
        type: CHOOSE_TARGETS_FROM_LIBRARY_GOAL,
        payload: { goalId, body },
    };
};

export const chooseOptionsFromLibraryGoal = (goalId, body) => {
    return {
        type: CHOOSE_OPTIONS_FROM_LIBRARY_GOAL,
        payload: { goalId, body },
    };
};

/** End */

/** Mastery Library */

export const changeLibraryGoalTargetMastery = (goalId, body) => {
    return {
        type: CHANGE_LIBRARY_GOAL_TARGET_MASTERY,
        payload: { goalId, body },
    };
};
export const changeLibraryGoalMastery = (goalId, body) => {
    return {
        type: CHANGE_LIBRARY_GOAL_MASTERY,
        payload: { goalId, body },
    };
};
export const changeSingleLibraryGoalTargetMastery = (goalId, targetId, body) => {
    return {
        type: CHANGE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY,
        payload: { goalId, targetId, body },
    };
};

export const removeSingleLibraryGoalTargetMastery = (goalId, targetId) => {
    return {
        type: REMOVE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY,
        payload: { goalId, targetId },
    };
};

/** End */

/** Target Maintenance */

export const changeLibraryTargetMaintenance = (goalId, body) => {
    return {
        type: CHANGE_LIBRARY_TARGET_MAINTENANCE,
        payload: { goalId, body },
    };
};

export const addLibraryTargetMaintenanceStep = (goalId, body) => {
    return {
        type: ADD_LIBRARY_TARGET_MAINTENANCE_STEP,
        payload: { goalId, body },
    };
};

export const editLibraryTargetMaintenanceStep = (goalId, stepId, body) => {
    return {
        type: EDIT_LIBRARY_TARGET_MAINTENANCE_STEP,
        payload: { goalId, stepId, body },
    };
};

export const deleteLibraryTargetMaintenanceStep = (goalId, stepId) => {
    return {
        type: DELETE_LIBRARY_TARGET_MAINTENANCE_STEP,
        payload: { goalId, stepId },
    };
};

/** End */

/** Single Target Maintenance */

export const changeSingleLibraryTargetMaintenance = (goalId, targetId, body) => {
    return {
        type: CHANGE_SINGLE_LIBRARY_TARGET_MAINTENANCE,
        payload: { goalId, targetId, body },
    };
};

export const addSingleLibraryTargetMaintenanceStep = (goalId, targetId, body) => {
    return {
        type: ADD_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP,
        payload: { goalId, targetId, body },
    };
};

export const editSingleLibraryTargetMaintenanceStep = (goalId, stepId, body) => {
    return {
        type: EDIT_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP,
        payload: { goalId, stepId, body },
    };
};

export const deleteSingleLibraryTargetMaintenanceStep = (goalId, targetId, stepId) => {
    return {
        type: DELETE_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP,
        payload: { goalId, targetId, stepId },
    };
};

export const singleLibraryTargetFollowGoalConfig = (goalId, targetId, body) => {
    return {
        type: SINGLE_LIBRARY_TARGET_FOLLOW_GOAL_CONFIG,
        payload: { goalId, targetId, body },
    };
};

export const singleLibraryTargetMasteryFollowGoal = (goalId, targetId, body) => {
    return {
        type: SINGLE_LIBRARY_TARGET_MASTERY_FOLLOW_GOAL,
        payload: { goalId, targetId, body },
    };
};

/** End */

/** Clinical Library Folders */

export const getLibraryFolders = (params, load) => {
    return {
        type: GET_LIBRARY_FOLDERS,
        payload: { params, load },
    };
};

export const createLibraryFolder = (body, params) => {
    return {
        type: CREATE_LIBRARY_FOLDER,
        payload: { body, params },
    };
};

export const editLibraryFolder = (id, body, params) => {
    return {
        type: EDIT_LIBRARY_FOLDER,
        payload: { id, body, params },
    };
};

export const deleteLibraryFolder = (id, params) => {
    return {
        type: DELETE_LIBRARY_FOLDER,
        payload: { id, params },
    };
};

/** End */

/** Targets */

export const createLibraryTarget = (folderId, body, requestFoldersParams) => {
    return {
        type: CREATE_LIBRARY_TARGET,
        payload: { folderId, body, requestFoldersParams },
    };
};
export const editLibraryTarget = (folderId, targetId, body, requestFoldersParams) => {
    return {
        type: EDIT_LIBRARY_TARGET,
        payload: { folderId, targetId, body, requestFoldersParams },
    };
};

export const deleteLibraryTarget = (folderId, targetId, requestFoldersParams) => {
    return {
        type: DELETE_LIBRARY_TARGET,
        payload: { folderId, targetId, requestFoldersParams },
    };
};

/** End */

/** Options */

export const createLibraryOption = (folderId, body, requestFoldersParams) => {
    return {
        type: CREATE_LIBRARY_OPTION,
        payload: { folderId, body, requestFoldersParams },
    };
};
export const editLibraryOption = (folderId, targetId, body, requestFoldersParams) => {
    return {
        type: EDIT_LIBRARY_OPTION,
        payload: { folderId, targetId, body, requestFoldersParams },
    };
};

export const deleteLibraryOption = (folderId, targetId, requestFoldersParams) => {
    return {
        type: DELETE_LIBRARY_OPTION,
        payload: { folderId, targetId, requestFoldersParams },
    };
};

/** End */
